$.constants = {
    menuHeight: 90,
};

$.refreshPriority = function (element) {
    const sections = Array.prototype.slice.call(
        document.querySelectorAll("section")
    );
    const index = sections.indexOf(element);

    return index < 0 ? 0 : -index;
};
